import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 5H1v18h18v-2H3V5zm11 9V6H9v5h3v1H9v2h5zm-3-5V8h1v1h-1zm12-8H5v18h18V1zm-2 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
}), 'Filter9PlusSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Filter9PlusSharp.js
// module id = 3620
// module chunks = 2